export default __webpack_public_path__ + "2464c160589f3a244cefebf7dcff0316.png";